// extracted by css-extract-rspack-plugin
export default {"rightSection":"Jyd_heKD","rightSectionEnd":"xEKJDh25","clickable":"j1bNznwe"};